export const cvrIndustryCodeToFcpRiskScore = {
    "011100": 1,
    "011200": 1,
    "011300": 1,
    "011400": 1,
    "011500": 5,
    "011600": 1,
    "011900": 1,
    "012100": 1,
    "012200": 1,
    "012300": 1,
    "012400": 1,
    "012500": 1,
    "012600": 1,
    "012700": 1,
    "012800": 2,
    "012900": 1,
    "013000": 1,
    "014100": 1,
    "014200": 1,
    "014300": 3,
    "014400": 3,
    "014500": 1,
    "014610": 1,
    "014620": 1,
    "014700": 1,
    "014800": 3,
    "015000": 2,
    "016100": 2,
    "016200": 2,
    "016300": 1,
    "017000": 5,
    "021000": 1,
    "022000": 1,
    "023000": 1,
    "024000": 2,
    "031100": 3,
    "031200": 3,
    "032100": 2,
    "032200": 2,
    "033000": 2,
    "051000": 5,
    "052000": 5,
    "061000": 5,
    "062000": 5,
    "071000": 5,
    "072100": 5,
    "072900": 5,
    "081100": 2,
    "081200": 2,
    "089100": 5,
    "089200": 2,
    "089300": 2,
    "089900": 5,
    "091000": 5,
    "099000": 5,
    "101110": 1,
    "101190": 1,
    "101200": 1,
    "101300": 2,
    "102010": 2,
    "102020": 2,
    "103100": 1,
    "103200": 1,
    "103900": 1,
    "104100": 1,
    "104200": 1,
    "105100": 1,
    "105200": 1,
    "106100": 1,
    "106200": 1,
    "107110": 1,
    "107120": 1,
    "107200": 1,
    "107300": 1,
    "108100": 2,
    "108200": 2,
    "108300": 1,
    "108400": 1,
    "108500": 2,
    "108600": 2,
    "108900": 2,
    "109100": 1,
    "109200": 1,
    "110100": 2,
    "110200": 2,
    "110300": 2,
    "110400": 2,
    "110500": 2,
    "110600": 2,
    "110700": 1,
    "120000": 5,
    "131000": 1,
    "132000": 1,
    "133000": 2,
    "139100": 1,
    "139200": 1,
    "139300": 2,
    "139400": 1,
    "139500": 1,
    "139600": 1,
    "139900": 2,
    "141000": 1,
    "142300": 1,
    "142100": 1,
    "142200": 1,
    "142400": 3,
    "142900": 1,
    "151100": 3,
    "151200": 2,
    "152000": 2,
    "161100": 1,
    "161200": 1,
    "162100": 1,
    "162200": 1,
    "162300": 1,
    "162400": 1,
    "162500": 1,
    "162600": 1,
    "162700": 1,
    "162800": 1,
    "171100": 1,
    "171200": 1,
    "172100": 1,
    "172200": 1,
    "172300": 1,
    "172400": 1,
    "172500": 1,
    "181100": 1,
    "181300": 1,
    "181400": 1,
    "182000": 1,
    "191000": 2,
    "192000": 5,
    "201100": 5,
    "201200": 2,
    "201300": 5,
    "201400": 5,
    "201500": 3,
    "201600": 2,
    "201700": 2,
    "202000": 3,
    "203000": 2,
    "204100": 1,
    "204200": 1,
    "205100": 5,
    "205900": 5,
    "206000": 2,
    "211000": 2,
    "181200": 2,
    "221100": 2,
    "221200": 2,
    "222100": 1,
    "222200": 1,
    "222300": 1,
    "222400": 1,
    "222500": 1,
    "222600": 1,
    "231100": 1,
    "231200": 1,
    "231300": 1,
    "231400": 1,
    "231500": 1,
    "232000": 1,
    "233100": 1,
    "233200": 2,
    "234100": 2,
    "234200": 2,
    "234300": 2,
    "234400": 2,
    "234500": 2,
    "235100": 2,
    "235200": 1,
    "236100": 2,
    "236200": 2,
    "236300": 2,
    "236400": 2,
    "236500": 2,
    "236600": 2,
    "237000": 1,
    "239100": 1,
    "239910": 2,
    "239990": 2,
    "241000": 2,
    "242000": 2,
    "243100": 1,
    "243200": 1,
    "243300": 1,
    "243400": 1,
    "244100": 3,
    "244200": 2,
    "244300": 2,
    "244400": 2,
    "244500": 2,
    "244600": 5,
    "245100": 2,
    "245200": 2,
    "245300": 2,
    "245400": 2,
    "251100": 2,
    "251200": 2,
    "252100": 2,
    "252200": 2,
    "253000": 5,
    "254000": 2,
    "255200": 2,
    "255100": 2,
    "255300": 2,
    "256100": 1,
    "256200": 2,
    "256300": 2,
    "259100": 2,
    "259200": 2,
    "259300": 2,
    "259400": 2,
    "259900": 2,
    "261100": 3,
    "261200": 3,
    "262000": 3,
    "263000": 3,
    "264000": 2,
    "265100": 3,
    "265200": 2,
    "266010": 2,
    "266090": 2,
    "267000": 3,
    "271100": 3,
    "271200": 3,
    "272000": 3,
    "273100": 2,
    "273200": 2,
    "273300": 2,
    "274000": 2,
    "275100": 2,
    "275200": 2,
    "279000": 3,
    "281100": 3,
    "281200": 3,
    "281300": 3,
    "281400": 2,
    "281500": 2,
    "282100": 2,
    "282200": 2,
    "282300": 2,
    "282400": 2,
    "282500": 2,
    "282900": 2,
    "283000": 2,
    "284100": 2,
    "284200": 2,
    "289100": 2,
    "289200": 3,
    "289300": 5,
    "289400": 2,
    "289500": 2,
    "289600": 2,
    "289700": 3,
    "289900": 3,
    "291000": 2,
    "292000": 2,
    "293100": 2,
    "293200": 2,
    "301100": 2,
    "301200": 2,
    "301300": 5,
    "302000": 2,
    "303100": 2,
    "303200": 5,
    "304000": 5,
    "309100": 2,
    "309200": 2,
    "309900": 3,
    "310000": 1,
    "321100": 2,
    "321200": 3,
    "321300": 3,
    "322000": 2,
    "323000": 1,
    "324000": 2,
    "325000": 2,
    "329100": 1,
    "329900": 2,
    "331100": 2,
    "331200": 2,
    "331300": 2,
    "331400": 2,
    "331500": 2,
    "331600": 2,
    "331700": 2,
    "331800": 5,
    "331900": 2,
    "332000": 2,
    "351100": 3,
    "351200": 3,
    "351300": 2,
    "351400": 2,
    "351510": 3,
    "351590": 3,
    "351600": 2,
    "352100": 4,
    "352200": 4,
    "352300": 4,
    "352400": 4,
    "353000": 3,
    "354000": 4,
    "360000": 3,
    "370000": 2,
    "381100": 2,
    "381200": 2,
    "382100": 3,
    "382200": 2,
    "382300": 3,
    "383100": 3,
    "383200": 3,
    "383300": 3,
    "390000": 3,
    "681200": 3,
    "410000": 3,
    "421100": 2,
    "421200": 2,
    "421300": 2,
    "422100": 2,
    "422200": 2,
    "429100": 2,
    "429900": 3,
    "431100": 3,
    "431200": 3,
    "431300": 3,
    "432100": 3,
    "432200": 3,
    "432300": 3,
    "432400": 3,
    "433100": 3,
    "433200": 3,
    "433300": 3,
    "433410": 3,
    "433420": 3,
    "433500": 3,
    "434100": 3,
    "434200": 3,
    "435000": 3,
    "436000": 2,
    "439100": 3,
    "439900": 3,
    "953110": 3,
    "467200": 3,
    "478200": 3,
    "461100": 2,
    "461200": 5,
    "461300": 2,
    "461400": 3,
    "461500": 2,
    "461600": 2,
    "461710": 3,
    "461790": 2,
    "461890": 2,
    "461810": 4,
    "461900": 2,
    "462100": 5,
    "462200": 2,
    "462300": 2,
    "462400": 2,
    "463100": 2,
    "463210": 2,
    "463300": 2,
    "463410": 2,
    "463420": 2,
    "463500": 5,
    "463600": 2,
    "463700": 2,
    "463220": 2,
    "463800": 2,
    "463900": 2,
    "464100": 2,
    "464210": 2,
    "464220": 2,
    "464310": 2,
    "464320": 2,
    "464410": 2,
    "464420": 2,
    "464500": 2,
    "464610": 2,
    "464620": 2,
    "464700": 2,
    "464800": 4,
    "464910": 2,
    "464920": 2,
    "464930": 2,
    "464990": 2,
    "465000": 3,
    "466100": 2,
    "466200": 2,
    "466300": 5,
    "466400": 2,
    "467100": 4,
    "468100": 5,
    "468200": 5,
    "468300": 2,
    "468400": 2,
    "468500": 5,
    "468600": 4,
    "468700": 3,
    "468900": 4,
    "469000": 3,
    "471110": 5,
    "471120": 3,
    "471130": 3,
    "471200": 3,
    "472100": 3,
    "472200": 3,
    "472300": 3,
    "472400": 4,
    "472500": 2,
    "472600": 3,
    "472700": 2,
    "467300": 4,
    "473000": 2,
    "474000": 2,
    "475100": 2,
    "475210": 2,
    "475220": 3,
    "475300": 2,
    "475400": 2,
    "475520": 1,
    "475510": 2,
    "475530": 2,
    "475590": 2,
    "476100": 2,
    "476200": 2,
    "476310": 2,
    "476320": 2,
    "476330": 2,
    "476400": 2,
    "476910": 3,
    "476920": 4,
    "476990": 4,
    "477110": 2,
    "477120": 2,
    "477210": 2,
    "477220": 2,
    "477300": 2,
    "477420": 2,
    "477410": 2,
    "477500": 2,
    "477610": 2,
    "477620": 2,
    "477700": 4,
    "477800": 3,
    "477900": 2,
    "478100": 3,
    "478300": 4,
    "479100": 4,
    "479200": 4,
    "491100": 2,
    "491200": 2,
    "492000": 3,
    "493100": 2,
    "493300": 3,
    "493400": 2,
    "493900": 3,
    "493200": 2,
    "494100": 3,
    "494200": 3,
    "495000": 2,
    "501000": 2,
    "502000": 4,
    "503000": 2,
    "504000": 2,
    "511010": 2,
    "511020": 2,
    "512100": 4,
    "512200": 3,
    "521000": 2,
    "522110": 2,
    "522120": 2,
    "522130": 2,
    "522210": 2,
    "522220": 2,
    "522300": 2,
    "522400": 3,
    "522500": 2,
    "522600": 2,
    "523100": 2,
    "523200": 2,
    "533000": 4,
    "531000": 2,
    "532000": 2,
    "551000": 2,
    "552000": 2,
    "553000": 2,
    "554000": 2,
    "559000": 2,
    "561110": 3,
    "561190": 3,
    "561200": 3,
    "562100": 3,
    "562200": 2,
    "563020": 3,
    "563010": 3,
    "564000": 2,
    "581100": 1,
    "581200": 1,
    "581300": 1,
    "581900": 1,
    "582100": 2,
    "582900": 2,
    "591100": 1,
    "591200": 1,
    "591300": 1,
    "591400": 1,
    "592000": 2,
    "601000": 1,
    "602000": 1,
    "603100": 1,
    "603900": 2,
    "611000": 2,
    "612000": 2,
    "619000": 2,
    "621000": 2,
    "622000": 2,
    "629000": 2,
    "631000": 2,
    "639100": 2,
    "639200": 2,
    "641100": 5,
    "641900": 5,
    "642110": 5,
    "642120": 2,
    "642130": 5,
    "642200": 5,
    "643110": 5,
    "643120": 5,
    "643200": 5,
    "649100": 5,
    "649210": 5,
    "649220": 5,
    "649230": 5,
    "649990": 5,
    "649910": 3,
    "651100": 5,
    "651200": 5,
    "652000": 5,
    "653010": 5,
    "653020": 5,
    "661100": 5,
    "661200": 5,
    "661900": 5,
    "662100": 4,
    "662200": 4,
    "662900": 5,
    "663000": 5,
    "681100": 2,
    "682010": 2,
    "682020": 2,
    "682030": 2,
    "682040": 2,
    "683110": 5,
    "683120": 2,
    "683210": 2,
    "683220": 2,
    "691000": 4,
    "692000": 2,
    "701010": 2,
    "701020": 5,
    "733000": 2,
    "702000": 2,
    "711100": 2,
    "711210": 2,
    "711220": 2,
    "711230": 2,
    "711240": 2,
    "711290": 2,
    "712010": 2,
    "712020": 2,
    "712090": 2,
    "722000": 1,
    "721000": 2,
    "731110": 2,
    "731190": 2,
    "731200": 2,
    "732000": 1,
    "741100": 2,
    "741200": 2,
    "741300": 2,
    "741400": 2,
    "742000": 1,
    "743000": 3,
    "749910": 2,
    "749100": 2,
    "749990": 2,
    "750000": 2,
    "771100": 4,
    "771200": 4,
    "772100": 2,
    "772200": 2,
    "773100": 2,
    "773200": 2,
    "773300": 2,
    "773400": 2,
    "773500": 2,
    "773910": 2,
    "773990": 2,
    "774000": 2,
    "775100": 4,
    "775200": 4,
    "781000": 4,
    "782000": 4,
    "791100": 4,
    "791200": 4,
    "799000": 4,
    "800100": 2,
    "800900": 3,
    "811000": 3,
    "812100": 3,
    "812210": 3,
    "812220": 3,
    "812290": 3,
    "812300": 3,
    "813000": 2,
    "821000": 2,
    "822000": 2,
    "823000": 2,
    "824000": 4,
    "829100": 4,
    "829200": 2,
    "829900": 2,
    "841100": 1,
    "841200": 1,
    "841300": 1,
    "842100": 1,
    "842200": 4,
    "842300": 1,
    "842400": 1,
    "842500": 1,
    "843000": 1,
    "851000": 1,
    "852010": 1,
    "852020": 1,
    "853110": 1,
    "853120": 1,
    "853200": 1,
    "853300": 1,
    "854000": 1,
    "855100": 3,
    "855200": 4,
    "855300": 3,
    "855900": 3,
    "856100": 2,
    "856900": 2,
    "861000": 1,
    "862100": 2,
    "862200": 2,
    "862300": 1,
    "869400": 2,
    "869500": 2,
    "869900": 2,
    "869100": 1,
    "869200": 1,
    "869300": 1,
    "869600": 3,
    "869700": 1,
    "871010": 1,
    "871020": 1,
    "872010": 2,
    "872020": 2,
    "873010": 2,
    "873020": 2,
    "879910": 2,
    "879920": 2,
    "879990": 2,
    "879100": 2,
    "879930": 3,
    "881010": 2,
    "881020": 2,
    "881030": 2,
    "889110": 2,
    "889120": 2,
    "889130": 2,
    "889140": 2,
    "889150": 2,
    "889160": 2,
    "889910": 3,
    "889920": 2,
    "889990": 2,
    "902020": 3,
    "903920": 3,
    "903100": 3,
    "901100": 3,
    "901200": 3,
    "901300": 3,
    "902010": 2,
    "903910": 2,
    "911100": 1,
    "911200": 1,
    "912100": 1,
    "912200": 1,
    "914100": 1,
    "913000": 1,
    "914200": 1,
    "920000": 5,
    "931100": 2,
    "931200": 3,
    "931300": 2,
    "931900": 3,
    "932100": 2,
    "932910": 2,
    "932990": 2,
    "941100": 2,
    "941200": 2,
    "942000": 2,
    "949100": 4,
    "949200": 3,
    "949900": 3,
    "951000": 2,
    "952100": 2,
    "952200": 2,
    "952300": 2,
    "952400": 2,
    "952500": 4,
    "952900": 2,
    "953120": 3,
    "953190": 3,
    "953200": 3,
    "954000": 2,
    "961010": 3,
    "961020": 3,
    "962100": 3,
    "962200": 3,
    "963000": 2,
    "969900": 3,
    "962300": 2,
    "964000": 3,
    "969100": 2,
    "970000": 2,
    "981000": 2,
    "982000": 2,
    "990020": 4,
    "990010": 5,
}
